
import CropFreeIcon from '@mui/icons-material/CropFree';
const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    

}

export const spShipperDetailsConfig = {
    details: {
        title: 'details',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    pickup: {
        title: 'sending',
        icon: <CropFreeIcon/>,
        options : [],
    },
    authorisation:  {
        title: 'authorisation',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    costs:  {
        title: 'costs',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    returnCosts:  {
        title: 'return_costs',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    fuelSurcharge:  {
        title: 'fuel_surcharge',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    surcharges:  {
        title: 'surcharges',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    },
    checkoutSettings: {
        title: 'checkout_settings',
        icon: <CropFreeIcon/>,
        //mobileactions added later
    }
};
